import {useState} from 'react';
import { PayPalButtons } from "@paypal/react-paypal-js";

/*

donde se quiera utilizar copiar estas lineas


import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import PaypalCheckoutButton from "../common/PaypalCheckoutButton";


<Item.Extra>
    <PayPalScriptProvider  options={{"client-id":process.env.REACT_APP_PAYPAL_CLIENT_ID,"currency":"USD", "locale":"es_MX"}}>
        <div className="paypal-button-container">
             <PaypalCheckoutButton curso={product} handleApprove={handleApprove} />
        </div>
    </PayPalScriptProvider>         
</Item.Extra>


///Manage

handleApprove = (orderID, order)=>{
        
}


*/

const PaypalCheckoutButton =(props) => {
    
    let curso = props.curso;

    
    
    const[paidFor, setPaidFor] =useState(false);
    const[error, setError] =useState(null);
    /*
    const handleApprove=(order)=>{
        
        //call back to fulfill order
        
        //if response true
        //console.log(order);
        setPaidFor(true);
        //refresh user's account or suscripcion status
        
        
        //if error
        //alert(#)
        
    
    
        if(paidFor){
            //mensaje de pago completado

            alert("gracias por su pago");

        }

        if(error){

            //mensaje de error
            alert(error);
        }
    }
    */
    return(
        <PayPalButtons 
        
            style={{
                color: "silver",
                height: 48,
                tagline: false,
                layout: 'horizontal',
                shape: "pill"
            }}
        
            onClick={(data, actions)=>{
        
                //validacion del boton 
                const hasAlredyBoughtCourse = false ;
        
                if(hasAlredyBoughtCourse){
                     setError("Tu ya tienes este curso");
                    //props.handleApprove();
                    return actions.reject();
                }else{
                    return actions.resolve();
                }
        
        
            }}
        
            createOrder={(data, actions)=>{
                
                return actions.order.create({
                    purchase_units: [
                            {
                                description:curso.descripcion,
                                amount: {
                                    value: curso.price,
                                }
                            },
                        ],
                })
        
            }}
            
            onApprove={async(data, actions)=>{
                       
                const order = await actions.order.capture();
                       
             
                    props.handleApprove(data.orderID, order);
             
            }}
            
            onCancel={()=>{
                //display cancel messeage          
            }}
            
            onError={(err)=>{
            
                setError(err);
                console.error("PayPal checkout onError", err);
            }}
        />
    )

};


export default PaypalCheckoutButton;